import React, { useState } from 'react'
import { WidgetContent, Select } from '@duik/it'
import CreateNewModal from '../UI/CreateNewModal'
import { ModalButton } from '../UI/ModalButton'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ViewMaterialModal from './ViewMaterialModal'

const MaterialsModal = props => {
  const [selectMaterialModal] = useState(true)
  const [viewMaterialModal, setViewMaterialModal] = useState(false)
  const [selectedMaterial, setSelectedMaterial] = useState()

  const materials =
    props.materials &&
    props.materials.map(material => {
      return { value: material._id, label: material.materialName }
    })

  const handleSelectedMaterial = _id => {
    if (_id !== 'new') {
      const selectedMaterial = props.materials.find(material => material._id === _id)
      setSelectedMaterial(selectedMaterial)
    } else {
      setSelectedMaterial(_id)
    }
  }

  const handleViewMaterialModal = () => {
    props.getMaterials()
    setViewMaterialModal(!viewMaterialModal)
  }

  const handleSubmit = values => {
    if (values && values.materialName === 'new') {
      setViewMaterialModal(true)
    }
    setViewMaterialModal(true)
  }

  return (
    <>
      {selectMaterialModal && (
        <CreateNewModal
          title="Materials"
          bannerText="Select a material or choose add new"
          handleCloseModal={props.materialsModalToggle}
        >
          <Formik
            initialValues={{
              materialName: ''
            }}
            validationSchema={MaterialSchema}
            handleSubmit={e => console.log('')}
            onSubmit={values => {
              handleSubmit(values)
            }}
            render={({
              values,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <WidgetContent
                  style={{
                    height: '355px',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: 0
                  }}
                >
                  <div style={{ paddingTop: '45px' }}>
                    <Select
                      className="threeQuarterWidthInputBox materials optionsFullWidth"
                      placeholder={['']}
                      menuPosition="bottom-left"
                      label="Material"
                      name="materialName"
                      options={
                        materials
                          ? [
                              {
                                value: 'new',
                                label: '+ Add New Material'
                              },
                              ...materials
                            ]
                          : [
                              {
                                value: 'new',
                                label: '+ Add New Material'
                              }
                            ]
                      }
                      position="bottomRight"
                      onOptionClick={e => {
                        setFieldValue('materialName', e.value)
                        handleSelectedMaterial(e.value)
                      }}
                    />
                    <ErrorMessage
                      name="materialName"
                      render={msg => (
                        <span
                          style={{
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </WidgetContent>

                <WidgetContent style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <div style={{ width: '83px' }}>
                    <ModalButton
                      success={values.materialName !== ''}
                      buttonStyle={values.materialName ? 'primary' : 'tertiary'}
                      type="submit"
                      name="OK"
                    />
                  </div>
                </WidgetContent>
              </form>
            )}
          />
        </CreateNewModal>
      )}
      {viewMaterialModal && (
        <ViewMaterialModal
          handleViewMaterialModal={handleViewMaterialModal}
          selectedMaterial={selectedMaterial}
          getMaterials={props.getMaterials}
          materialsModalToggle={props.materialsModalToggle}
        />
      )}
    </>
  )
}

export default MaterialsModal

const MaterialSchema = Yup.object().shape({
  materialName: Yup.string().required('Required')
})
